import { Component, OnInit, forwardRef, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NG_VALIDATORS, Validator, ValidationErrors, AbstractControl } from '@angular/forms';
import { RecaptchaDirective } from '../../directives/recaptcha.directive';

@Component({
    selector: 'app-captcha',
    templateUrl: './captcha.component.html',
    styleUrls: ['./captcha.component.less'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CaptchaComponent),
        multi: true
    },
    {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => CaptchaComponent),
        multi: true
    }]
})

export class CaptchaComponent implements OnInit, ControlValueAccessor, Validator {
    @ViewChild(RecaptchaDirective) recaptcha: RecaptchaDirective;
    @Output() verified: EventEmitter<string> = new EventEmitter<string>();
    @Output() expired: EventEmitter<any> = new EventEmitter<any>();

    ngOnInit() {
    }

    challenge(): void {
        this.recaptcha.challengeUser();
    }

    reset(): void {
        window.grecaptcha.reset();
    }

    captchaVerified(token: string): void {
        this.propagateTouched();
        this.propagateChange(token);
        this.verified.emit(token);
    }

    captchaExpired(): void {
        this.propagateTouched();
        this.propagateChange(null);

        this.expired.emit();
        console.warn('Captcha challenge expired!');
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;

        // if (this.captchaToken === null) {
        //   return { 'captchaMissing': true };
        // }

        // return null;
    }

    // --- ControlValueAccessor members

    writeValue(obj: any): void {
        // This isn't really possible since the only one to actually generate a token is the reCaptcha code itself.
    }

    propagateChange = (_: any) => { };

    propagateTouched = () => { };

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.propagateTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void { }
}
